// extracted by mini-css-extract-plugin
export default {"answerLabel":"bC_dF","success":"bC_dG"};